import { Component, inject, OnInit } from '@angular/core';
import { SsoRedirectorService } from '../../services/sso-redirector.service';
import { LEGACY_SSO } from 'src/app/tokens';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-legacy-sso',
  templateUrl: './legacy-sso.component.html',
  styleUrl: './legacy-sso.component.scss'
})
export class LegacySsoComponent implements OnInit {
  ssoRedirector = inject(SsoRedirectorService);
  legacyConfig = inject(LEGACY_SSO);
  router = inject(Router);
  route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.ssoRedirector.ssoSamlOutBound(
        this.legacyConfig.idpUrl,
        this.legacyConfig.serviceUrl,
        this.legacyConfig.issuer,
        params.guid
      );

      this.router.navigate(['/']);
    });
  }
}
